module.exports = __webpack_public_path__ + "img/prod-detail1.b160a715.jpg";